<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19NM92l/tc-custom/9781597144469.jpg?1716662495963" alt="This image is the cover for the book Life After Manzanar"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Life After Manzanar
      </h1>
      <p class="bookDescription body article font2">
        <p>“<b>A compelling account of the lives of Japanese and Japanese Americans incarcerated during World War II . . . instructive and moving.”—Nippon.com</b><br/>  <br/> From the editor of the award-winning <i>Children of Manzanar</i>, Heather C. Lindquist, and Edgar Award winner Naomi Hirahara comes a nuanced account of the “Resettlement”: the relatively unexamined period when ordinary people of Japanese ancestry, having been unjustly imprisoned during World War II, were finally released from custody. Given twenty-five dollars and a one-way bus ticket to make a new life, some ventured east to Denver and Chicago to start over, while others returned to Southern California only to face discrimination and an alarming scarcity of housing and jobs.<br/>  <br/> Hirahara and Lindquist weave new and archival oral histories into an engaging narrative that illuminates the lives of former internees in the postwar era, both in struggle and unlikely triumph. Readers will appreciate the painstaking efforts that rebuilding required and will feel inspired by the activism that led to redress and restitution—and that built a community that even now speaks out against other racist agendas.<br/>  <br/> “Through this thoughtful story, we see how the harsh realities of the incarceration experience follow real lives, and how Manzanar will sway generations to come. When you finish the last chapter you will demand to read more.”—Gary Mayeda, national president of the Japanese American Citizens League<br/><br/> “An engaging, well-written telling of how former Manzanar detainees played key roles in remembering and righting the wrong of the World War II incarceration.”—Tom Ikeda, executive director of Densho</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Naomi Hirahara, Heather C. Lindquist, Art Hansen
      </h2>
      
      <p class="authorDescription body article">Naomi Hirahara, born and raised in Southern California, is the Edgar Award-winning author of the Mas Arai mystery series, which features a Japanese American gardener and atomic-bomb survivor who solves crimes (SUMMER OF THE BIG BACHI, GASA-GASA GIRL, SNAKESKIN SHAMISEN, BLOOD HINA and STRAWBERRY YELLOW). Books in this series have been translated into Japanese, Korean and French (September 2015 publication date). MURDER ON BAMBOO LANE, her new mystery series with a female twentysomething LAPD bicycle cop, was released with Berkley Prime Crime in spring 2014. Her next in the series, A GRAVE ON GRAND AVENUE, was released in April 2015.She also has penned a middle-grade novel, 1001 CRANES, which was chosen as an Honor Book for the Youth Literature of the Asian/Pacific American Award for Literature in 2009.A former editor of the largest Japanese American newspaper in the U.S., she also has released a number of nonfiction works. A number of her short stories have been included in various anthologies.For more information, go to her website, www.naomihirahara.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Heyday
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7c9b2ee2